<h2 mat-dialog-title>
  <mat-icon style="vertical-align: middle; color: #451725;">security</mat-icon>
  Autenticación MFA
</h2>

<mat-dialog-content>
  <p>{{ 'PLEASEENTERSECURITYCODE' | translate }}</p>
  
  <mat-form-field appearance="outline">
    <mat-label>{{ 'MFACODE' | translate }}</mat-label>
    <input matInput [(ngModel)]="mfaCode" maxlength="6" placeholder="######" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'CANCEL' | translate }}</button>
  <button mat-raised-button color="primary" (click)="onSubmit()">{{ 'VALIDATE' | translate }}</button>
</mat-dialog-actions>
